import "./stats.css"
import 'react-notifications/lib/notifications.css'
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { FaCoins, FaGem, FaLock, FaGamepad, FaUsers, FaChartLine, FaStore } from "react-icons/fa"
import AdminLayout from "../../../components/AdminLayout"

//Components
import AdminService from "../../../services/admin_services"

const d = new Date();


class AdminStats extends Component {
    constructor(props) {
        super(props)
        this.state = {
            selected_action: 0,
            actions_info: {},
            period_average: {},
            stars_daily_average: {},
            stars_daily_stats: {},
            safes_daily_stats: {},
            safes_stats: {},
            end_date: new Date().toISOString().substring(0, 10),
            start_date: new Date(d.setMonth(new Date().getMonth() - 1)).toISOString().substring(0, 10),
            options_stars: null,
            series_star: null,
        }
    }

    componentDidMount = async () => {
        await this.loadStats()
    }

    loadStats = async () => {
        const stars = await AdminService.getStarsUsage(this.state.start_date, this.state.end_date, this.state.selected_action)
        const safes = await AdminService.getSafesUsage(this.state.start_date, this.state.end_date)
        const actions_by_player = [], nb_actions = [], nb_players = [], nb_stars = [], stars_by_action = [], stars_by_player = []
        Object.keys(stars.daily_stats).map(key => actions_by_player.push(stars.daily_stats[key].actions_by_player))
        Object.keys(stars.daily_stats).map(key => nb_actions.push(stars.daily_stats[key].nb_actions))
        Object.keys(stars.daily_stats).map(key => nb_players.push(stars.daily_stats[key].nb_players))
        Object.keys(stars.daily_stats).map(key => nb_stars.push(stars.daily_stats[key].nb_stars))
        Object.keys(stars.daily_stats).map(key => stars_by_action.push(stars.daily_stats[key].stars_by_action))
        Object.keys(stars.daily_stats).map(key => stars_by_player.push(stars.daily_stats[key].stars_by_player))
        this.setState({
            actions_info: stars.actions_info,
            period_average: stars.period_average,
            stars_daily_average: stars.daily_average,
            stars_daily_stats: stars.daily_stats,
            safes_daily_stats: safes.daily_stats,
            safes_stats: safes.safes_stats,
            options_stars: { chart: { id: "stars-bar" }, xaxis: { categories: Object.keys(stars.daily_stats) } },
            actions_by_player: [{ name: "stars", data: actions_by_player }],
            nb_actions: [{ name: "stars", data: nb_actions }],
            nb_players: [{ name: "stars", data: nb_players }],
            nb_stars: [{ name: "stars", data: nb_stars }],
            stars_by_action: [{ name: "stars", data: stars_by_action }],
            stars_by_player: [{ name: "stars", data: stars_by_player }],
        })
    }

    render() {
        return (
            <AdminLayout 
                title="Statistics Dashboard"
                breadcrumbs={[{ label: 'Statistics' }]}
            >
                <div className="space-y-6">
                    {/* Page Header */}
                    <div className="bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 rounded-xl shadow-lg p-8 text-white">
                        <div className="flex items-center gap-4 mb-4">
                            <div className="p-4 bg-white/20 rounded-xl backdrop-blur-sm">
                                <FaChartLine className="text-4xl" />
                            </div>
                            <div>
                                <h2 className="text-3xl font-bold">Analytics Dashboard</h2>
                                <p className="text-white/90 mt-1">Monitor your application's key performance metrics</p>
                            </div>
                        </div>
                    </div>

                    {/* Stats Cards Grid */}
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                        {/* Stars Statistics */}
                        <div 
                            onClick={() => window.location.href = '/admin/stats/stars'}
                            className="group bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden hover:shadow-2xl transition-all duration-300 cursor-pointer transform hover:-translate-y-1"
                        >
                            <div className="bg-gradient-to-br from-amber-400 to-yellow-500 p-6">
                                <div className="flex items-center justify-between">
                                    <FaCoins className="text-5xl text-white drop-shadow-lg" />
                                    <div className="text-right">
                                        <div className="text-white/90 text-sm font-medium uppercase tracking-wide">Coins</div>
                                        <div className="text-white text-2xl font-bold mt-1">Analytics</div>
                                    </div>
                                </div>
                            </div>
                            <div className="p-6">
                                <h3 className="text-lg font-bold text-gray-900 mb-2">Coins Statistics</h3>
                                <p className="text-gray-600 text-sm mb-4">Track Coins distribution, usage patterns, and player engagement metrics</p>
                                <div className="flex items-center text-amber-600 font-semibold group-hover:gap-3 transition-all">
                                    <span>View Details</span>
                                    <span className="transform group-hover:translate-x-1 transition-transform">→</span>
                                </div>
                            </div>
                        </div>

                        {/* Gems Statistics */}
                        <div 
                            onClick={() => window.location.href = '/admin/stats/gems'}
                            className="group bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden hover:shadow-2xl transition-all duration-300 cursor-pointer transform hover:-translate-y-1"
                        >
                            <div className="bg-gradient-to-br from-purple-500 to-pink-500 p-6">
                                <div className="flex items-center justify-between">
                                    <FaGem className="text-5xl text-white drop-shadow-lg" />
                                    <div className="text-right">
                                        <div className="text-white/90 text-sm font-medium uppercase tracking-wide">Gems</div>
                                        <div className="text-white text-2xl font-bold mt-1">Analytics</div>
                                    </div>
                                </div>
                            </div>
                            <div className="p-6">
                                <h3 className="text-lg font-bold text-gray-900 mb-2">Gems Statistics</h3>
                                <p className="text-gray-600 text-sm mb-4">Monitor gem transactions, player spending, and economy balance</p>
                                <div className="flex items-center text-purple-600 font-semibold group-hover:gap-3 transition-all">
                                    <span>View Details</span>
                                    <span className="transform group-hover:translate-x-1 transition-transform">→</span>
                                </div>
                            </div>
                        </div>

                        {/* Safes Statistics */}
                        <div 
                            onClick={() => window.location.href = '/admin/stats/safes'}
                            className="group bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden hover:shadow-2xl transition-all duration-300 cursor-pointer transform hover:-translate-y-1"
                        >
                            <div className="bg-gradient-to-br from-emerald-500 to-green-500 p-6">
                                <div className="flex items-center justify-between">
                                    <FaLock className="text-5xl text-white drop-shadow-lg" />
                                    <div className="text-right">
                                        <div className="text-white/90 text-sm font-medium uppercase tracking-wide">Safes</div>
                                        <div className="text-white text-2xl font-bold mt-1">Analytics</div>
                                    </div>
                                </div>
                            </div>
                            <div className="p-6">
                                <h3 className="text-lg font-bold text-gray-900 mb-2">Safes Statistics</h3>
                                <p className="text-gray-600 text-sm mb-4">Analyze safe opening rates, rewards distribution, and player behavior</p>
                                <div className="flex items-center text-emerald-600 font-semibold group-hover:gap-3 transition-all">
                                    <span>View Details</span>
                                    <span className="transform group-hover:translate-x-1 transition-transform">→</span>
                                </div>
                            </div>
                        </div>

                        {/* Games Statistics */}
                        <div 
                            onClick={() => window.location.href = '/admin/stats/games'}
                            className="group bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden hover:shadow-2xl transition-all duration-300 cursor-pointer transform hover:-translate-y-1"
                        >
                            <div className="bg-gradient-to-br from-red-500 to-orange-500 p-6">
                                <div className="flex items-center justify-between">
                                    <FaGamepad className="text-5xl text-white drop-shadow-lg" />
                                    <div className="text-right">
                                        <div className="text-white/90 text-sm font-medium uppercase tracking-wide">Games</div>
                                        <div className="text-white text-2xl font-bold mt-1">Analytics</div>
                                    </div>
                                </div>
                            </div>
                            <div className="p-6">
                                <h3 className="text-lg font-bold text-gray-900 mb-2">Game Statistics</h3>
                                <p className="text-gray-600 text-sm mb-4">Review gameplay sessions, match data, and competitive metrics</p>
                                <div className="flex items-center text-red-600 font-semibold group-hover:gap-3 transition-all">
                                    <span>View Details</span>
                                    <span className="transform group-hover:translate-x-1 transition-transform">→</span>
                                </div>
                            </div>
                        </div>

                        {/* Players Statistics */}
                        <div 
                            onClick={() => window.location.href = '/admin/stats/players'}
                            className="group bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden hover:shadow-2xl transition-all duration-300 cursor-pointer transform hover:-translate-y-1"
                        >
                            <div className="bg-gradient-to-br from-blue-500 to-cyan-500 p-6">
                                <div className="flex items-center justify-between">
                                    <FaUsers className="text-5xl text-white drop-shadow-lg" />
                                    <div className="text-right">
                                        <div className="text-white/90 text-sm font-medium uppercase tracking-wide">Players</div>
                                        <div className="text-white text-2xl font-bold mt-1">Analytics</div>
                                    </div>
                                </div>
                            </div>
                            <div className="p-6">
                                <h3 className="text-lg font-bold text-gray-900 mb-2">Players Statistics</h3>
                                <p className="text-gray-600 text-sm mb-4">Examine player growth, retention rates, and user engagement trends</p>
                                <div className="flex items-center text-blue-600 font-semibold group-hover:gap-3 transition-all">
                                    <span>View Details</span>
                                    <span className="transform group-hover:translate-x-1 transition-transform">→</span>
                                </div>
                            </div>
                        </div>

                        {/* Business Statistics */}
                        <div
                            onClick={() => window.location.href = '/admin/stats/business'}
                            className="group bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden hover:shadow-2xl transition-all duration-300 cursor-pointer transform hover:-translate-y-1"
                        >
                            <div className="bg-gradient-to-br from-orange-500 to-red-500 p-6">
                                <div className="flex items-center justify-between">
                                    <FaStore className="text-5xl text-white drop-shadow-lg" />
                                    <div className="text-right">
                                        <div className="text-white/90 text-sm font-medium uppercase tracking-wide">Business</div>
                                        <div className="text-white text-2xl font-bold mt-1">Analytics</div>
                                    </div>
                                </div>
                            </div>
                            <div className="p-6">
                                <h3 className="text-lg font-bold text-gray-900 mb-2">Business Statistics</h3>
                                <p className="text-gray-600 text-sm mb-4">Track visits, unique players, scans, and card distributions</p>
                                <div className="flex items-center text-orange-600 font-semibold group-hover:gap-3 transition-all">
                                    <span>View Details</span>
                                    <span className="transform group-hover:translate-x-1 transition-transform">→</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Quick Access Tips */}
                    <div className="bg-blue-50 border border-blue-200 rounded-xl p-6">
                        <div className="flex items-start gap-3">
                            <div className="p-2 bg-blue-100 rounded-lg">
                                <FaChartLine className="text-blue-600 text-xl" />
                            </div>
                            <div>
                                <h4 className="font-semibold text-blue-900 mb-1">Quick Tip</h4>
                                <p className="text-blue-800 text-sm">Click any card to dive into detailed analytics. Use the date range filters on each page to analyze specific time periods.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </AdminLayout>
        )
    }
}

export default withTranslation()(AdminStats)